<i [class]="iconClass()"></i>
@if(messageType() && labels.messages[messageType()!]){
<span class="icon-text">{{labels.messages[messageType()!]!()|titlecase}}</span>
}

@if(text()){
<div>{{ text() }}</div>
}